/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var DrawerToggleIcon = createIcon("DrawerToggleIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#000';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "10",
    height: "44",
    viewBox: "0 0 10 44",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "4",
    fill: _color
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "39",
    r: "4",
    fill: _color
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "22",
    r: "4",
    fill: _color
  }));
}, {
  "replaceColor": true
});